import { render } from "./aio-login-recaptcha-popup.vue?vue&type=template&id=32824517&scoped=true"
import script from "./aio-login-recaptcha-popup.vue?vue&type=script&lang=js"
export * from "./aio-login-recaptcha-popup.vue?vue&type=script&lang=js"

import "./aio-login-recaptcha-popup.vue?vue&type=style&index=0&id=32824517&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32824517"]])

export default __exports__